export default {
  UNREAD_COUNT_DISPLAY_LIMIT: 100 // 未読件数の表示境界値（100以上は「...」と表示）
};
